<template>
  <card
    style="height: 100%;"
    v-loading="loading"
    element-loading-background="rgba(0, 0, 0, 0.3)"
  >
    <div v-if="teles.length === 1" class="device-picker">
      {{ teles[0].name }}
    </div>

    <warning
      :height="Math.floor(height / 3)"
      :loading="loading"
      :data="warnings"
    ></warning>

    <div class="card-item">
      <div class="subtitle">
        - 虫量变化趋势
      </div>

      <echart
        chart-id="tele"
        v-if="!loading"
        :options="options"
        :height="Math.floor((height / 3) * 2)"
        :not-merge="true"
        @update-axis-pointer="updatePieValue"
      ></echart>
      <div
        v-else
        :style="{ height: `${Math.floor((height / 3) * 2)}px` }"
      ></div>
    </div>
  </card>
</template>

<script>
import mixin from '../mixin'
import Card from '../card'
import Warning from './warning'
import Echart from '@/components/Chart'
import { getWarnings } from '@/service/telemetry'
import colors from '@/utlis/colors'
import sleep from '@/utlis/sleep'

export default {
  mixins: [mixin],
  components: { Card, Warning, Echart },
  props: { sites: Array },
  data() {
    return {
      loading: false,
      pointer: null,
      warnings: [],
      trends: [],
      options: {},
      deviceData: []
    }
  },
  computed: {
    deviceId() {
      if (this.devKey) {
        const dev = this.teles.find(t => t.key === this.devKey)
        return dev.id
      } else {
        return ''
      }
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    async getData() {
      this.loading = true

      const [{ data }] = await Promise.all([
        getWarnings(this.companyId),
        sleep(1)
      ])
      this.trends = data.trends
      let ls = this.sites.map(st => {
        let devs = st.devices.lamp
        let insects = []
        let current = 0
        let last = 0
        data.warnings.forEach(w => {
          if (devs.includes(w.key)) {
            current += w.today
            last += w.yesterday

            let idx = insects.findIndex(i => i.id === w.categoryId)
            if (idx > -1) {
              insects[idx] = {
                ...insects[idx],
                current: insects[idx].current + w.today,
                last: insects[idx].last + w.yesterday
              }
            } else {
              insects.push({
                id: w.categoryId,
                name: w.category,
                current: w.today,
                last: w.yesterday
              })
            }
          }
        })
        return {
          name: st.name,
          insects: insects.sort((a, b) => b.current - a.current),
          current,
          last
        }
      })
      this.warnings = ls
      this.setOptions()
    },
    setOptions() {
      if (!(this.trends && this.trends[0])) return {}
      let xaxis = this.trends[0].data.map(d => d.date)
      let series = this.sites.map((st, idx) => {
        return {
          devs: st.devices.lamp,
          name: st.name,
          type: 'bar',
          data: {},
          label: {
            show: true,
            formatter: ({ data }) => {
              return data > 0 ? data : ''
            }
          },
          xAxisIndex: idx,
          yAxisIndex: idx
        }
      })
      this.trends.forEach(cate => {
        cate.data.forEach(date => {
          date.devices.forEach(o => {
            let idx = series.findIndex(s => s.devs.includes(o.key))
            if (idx > -1) {
              series[idx].data[date.date] = series[idx].data[date.date]
                ? (series[idx].data[date.date] += o.qty)
                : o.qty
            }
          })
        })
      })
      series = series.map(s => ({
        ...s,
        data: Object.values(s.data)
      }))
      this.options = {
        color: colors,
        legend: {
          show: false,
          left: 8,
          right: '6%',
          bottom: 24,
          type: 'scroll',
          pageButtonPosition: 'end',
          pageIconSize: 16,
          textStyle: { color: '#9aa8d4' },
          pageTextStyle: { color: '#dcdfe6', fontSize: 14 }
        },
        tooltip: {
          trigger: 'axis',
          confine: false,
          appendToBody: false
        },
        xAxis: [
          { type: 'category', boundaryGap: false, data: xaxis, gridIndex: 0 },
          { type: 'category', boundaryGap: false, data: xaxis, gridIndex: 1 },
          { type: 'category', boundaryGap: false, data: xaxis, gridIndex: 2 },
          { type: 'category', boundaryGap: false, data: xaxis, gridIndex: 3 }
        ],
        yAxis: [
          { show: false, splitLine: { show: false }, gridIndex: 0 },
          { show: false, splitLine: { show: false }, gridIndex: 1 },
          { show: false, splitLine: { show: false }, gridIndex: 2 },
          { show: false, splitLine: { show: false }, gridIndex: 3 }
        ],
        grid: series.map((s, i) => {
          let height = Math.floor((100 - 4) / series.length)
          let top = 4 + i * height
          let bottom = 100 - (top + height - 8)
          return { top: `${top}%`, bottom: `${bottom}%`, left: 44, right: 32 }
        }),
        series
      }

      this.loading = false
    },
    updatePieValue(evt) {
      let xAxisInfo = evt.axesInfo[0]
      if (xAxisInfo) {
        this.pointer = Math.round(xAxisInfo.value + 1)
      }
    }
  }
}
</script>

<style lang="css" scoped></style>
